module.exports = __webpack_public_path__ + "static/media/bulk_upload_fleet_performance.9d6818c6.csv";